import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next"
import { clx } from "../../../../helpers/components"
import { SectionHeader } from "../../../shared/TitleHeader"
import { Button } from "../../../ui/Button"
import style from "./style.module.scss"

export const ModernTestimonialSection = () => {
    const { t } = useTranslation("translations")
    const [currentIndex, setCurrentIndex] = useState(0)
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768)
        }
        
        checkMobile()
        window.addEventListener('resize', checkMobile)
        
        return () => window.removeEventListener('resize', checkMobile)
    }, [])

    const testimonials = [
        {
            id: 1,
            imgSrc: "/images/testimonial_Namegoli-Camba.png",
            clientName: "Namegoli Camba",
            clientCountryName: "Togo",
            message: t("home-page.testimonial-section.testimonial-1"),
            platform: "trustpilot",
            platformLabel: "Trustpilot",
            reviewUrl: "https://www.trustpilot.com/users/69777a6a6709075d5e3be4e0"
        },
          {
            id: 2,
            imgSrc: null,
            clientName: "Manzamasso Jacques AKETI",
            clientCountryName: "",
            message: t("home-page.testimonial-section.testimonial-8"),
            platform: "google",
            platformLabel: "Google Play",
            reviewUrl: "https://play.google.com/store/apps/details?id=com.izichange&pcampaignid=web_share"
        },
         
        {
            id: 3,
            imgSrc: null,
            clientName: "Varline Fotsap",
            clientCountryName: "Cameroun",
            message: t("home-page.testimonial-section.testimonial-7"),
            platform: "trustpilot",
            platformLabel: "Trustpilot",
            reviewUrl: "https://trustpilot.com/reviews/694ebd9a761722dc70c8f86f"
        },
        {
            id: 4,
            imgSrc: "/images/testimonial-Sebastien-Donan.png",
            clientName: "Sébastien Donan KOUGBLENOU",
            clientCountryName: "Bénin",
            message: t("home-page.testimonial-section.testimonial-6"),
            platform: "trustpilot",
            platformLabel: "Trustpilot",
            reviewUrl: "https://trustpilot.com/reviews/69738c28c0a17e10459b4f25"
        },
       
       
        {
            id: 5,
            imgSrc: null,
            clientName: "Rachel Congo",
            clientCountryName: "Niger",
            message: t("home-page.testimonial-section.testimonial-5"),
            platform: "trustpilot",
            platformLabel: "Trustpilot",
            reviewUrl: "https://trustpilot.com/reviews/69cdeaf1227a9219e85a0c0"
        },
        
      
        {
            id: 6,
            imgSrc: null,
            clientName: "Aristide Kodzo Dzifa LOUMON",
            clientCountryName: "",
            message: t("home-page.testimonial-section.testimonial-9"),
            platform: "google",
            platformLabel: "Google Play",
            reviewUrl: "https://play.google.com/store/apps/details?id=com.izichange&pcampaignid=web_share"
        },
        {
            id: 7,
            imgSrc: null,
            clientName: "Abdoulaye Traoré",
            clientCountryName: "",
            message: t("home-page.testimonial-section.testimonial-10"),
            platform: "google",
            platformLabel: "Google Play",
            reviewUrl: "https://play.google.com/store/apps/details?id=com.izichange&pcampaignid=web_share"
        }
    ]

    const visibleTestimonials = isMobile 
        ? [testimonials[currentIndex]]
        : [
            testimonials[currentIndex],
            testimonials[(currentIndex + 1) % testimonials.length],
            testimonials[(currentIndex + 2) % testimonials.length]
        ]

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % testimonials.length)
    }

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length)
    }

    return (
        <div className="container">
            <div className={style.testimonialContainer}>
                <SectionHeader
                    title={t("home-page.modern-testimonial-section.title")}
                    position="center"
                />
                
                <div className={style.carouselWrapper}>
                    <button 
                        className={`${style.navButton} ${style.prevBtn}`}
                        onClick={handlePrev}
                        aria-label="Previous testimonials"
                    >
                        ←
                    </button>

                    <div className={style.testimonialsWrapper}>
                        {visibleTestimonials.map((testimonial) => (
                            <ModernTestimonialCard
                                key={testimonial.id}
                                testimonial={testimonial}
                            />
                        ))}
                    </div>

                    <button 
                        className={`${style.navButton} ${style.nextBtn}`}
                        onClick={handleNext}
                        aria-label="Next testimonials"
                    >
                        →
                    </button>
                </div>

                <div className={style.ctaSection}>
                    <a href="https://www.trustpilot.com/evaluate/izichange.com " target="_blank" rel="noopener noreferrer">

                    <Button className={clx(style.ctaButton)} ariaLabel={t("home-page.modern-testimonial-section.submitReview")} bgColor="izi-primary-color" color="#fff">
                        {t("home-page.modern-testimonial-section.submitReview")}
                       
                    </Button>
                    </a>
                </div>
            </div>
        </div>
    )
}

const ModernTestimonialCard = ({ testimonial }) => {
    const { t } = useTranslation("translations")

    const getPlatformUrl = (platform) => {
        switch(platform) {
            case 'google':
                return 'https://play.google.com/store/apps/details?id=com.izichange&hl=fr'
            case 'trustpilot':
                return 'https://www.trustpilot.com/review/izichange.com'
            case 'facebook':
                return '#facebook-reviews'
            default:
                return '#'
        }
    }

    const getInitials = (name) => {
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2)
    }

    const reviewUrl = testimonial.reviewUrl || getPlatformUrl(testimonial.platform)

    return (
        <div className={style.modernCard}>
            <div className={style.cardContent}>
                {/* Profile + Name */}
                <div className={style.clientHeader}>
                    {testimonial.imgSrc ? (
                        <img 
                            src={testimonial.imgSrc} 
                            alt={testimonial.clientName}
                            className={style.avatar}
                        />
                    ) : (
                        <div className={style.avatarInitials}>
                            {getInitials(testimonial.clientName)}
                        </div>
                    )}
                    <div className={style.nameCountry}>
                        <p className={style.clientName}>{testimonial.clientName}</p>
                        <p className={style.clientCountry}>{testimonial.clientCountryName}</p>
                    </div>
                </div>

                {/* Stars */}
                <div className={style.starsContainer}>
                    {[...Array(5)].map((_, i) => (
                        <span key={i} className={style.star}>★</span>
                    ))}
                </div>

                {/* Message */}
                <p className={style.testimonialText}>
                    "{testimonial.message}"
                </p>

                {/* Platform Link */}
                <div className={style.platformLink}>
                    <a href={getPlatformUrl(testimonial.platform)} className={style.platformName}>
                        {testimonial.platformLabel}
                    </a>
                </div>

                {/* View Review Button */}
                <a href={reviewUrl} target="_blank" rel="noopener noreferrer" className={style.viewReviewBtn}>
                    {t("home-page.modern-testimonial-section.viewReview")}
                </a>
            </div>
        </div>
    )
}
